<div class="logo">
    <a href="/" class="simple-text">
        <div class="logo-img">
        </div>
        {{ 'MENU.TITLE' | translate }}
    </a>
</div>
<div class="sidebar-wrapper">
    <ul class="nav">
        <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{menuItem.class}} nav-item">
            <a class="nav-link" [routerLink]="[menuItem.path]">
                <i class="material-icons">{{menuItem.icon}}</i>
                <p>{{menuItem.title| translate}}</p>
            </a>
        </li>

        <li [ngClass]="{'logout-big-screen':bigScreen,'logout-small-screen':!bigScreen}"
            class="logout-big-screen nav-item" (click)="onLogout()">
            <a class="nav-link">
                <i class="material-icons">logout</i>
                <p>{{ 'MENU.LOGOUT' | translate }}</p>
            </a>
        </li>
    </ul>
</div>
